import "./grideditor.scss";
import { type FC, type ReactNode } from "react";
import { DndProvider } from "react-dnd";
import { TouchBackend } from "react-dnd-touch-backend";
import { type GridCursorType } from "./Cursor/GridCursor";
import { GridEditorContent } from "./GridEditorContent";

export interface GridItemType {
    id: string;
    top: number;
    left: number;
    width: number;
    height: number;
}

export type GridValidCallback = (id: string, cursor: GridCursorType) => boolean;

export interface GridEditorProps {
    width: number;
    height: number;
    columnSize?: number;
    rowSize?: number;
    wrapperClass?: string;
    items: Array<GridItemType>;
    onChange: (id: string, cursor: GridCursorType) => void;
    onDelete: (id: string) => void;
    onValid?: GridValidCallback;
    renderItem: (item: GridItemType) => ReactNode;
    selected: null | string;
    onSelect: (key: null | string) => void;
    highlight?: null | string;
}

export const GRID_SELECTED_DEPTH = 100;
export const GRID_CURSOR_DEPTH = 101;
export const GRID_ON_TOP_DEPTH = 102;
export const GRID_DROP_DEPTH = 103;

export const GridEditor: FC<GridEditorProps> = (props) => (
    <DndProvider
        backend={TouchBackend}
        options={{
            enableMouseEvents: true,
        }}
    >
        <GridEditorContent
            {...props}
        />
    </DndProvider>
);
